import React from 'react';
import { AiEngine } from '@picsio/icons';
import { Icon as IconContainer } from '@picsio/ui';

import localization from '../../shared/strings';
import styles from './styles.module.scss';

const VisualSearchOnBanner = () => (
  <div className={styles.onBanner}>
    <IconContainer size="md">
      <AiEngine className={styles.onBannerIcon} />
    </IconContainer>
    <span className={styles.onBannerText}>{localization.VISUAL_SEARCH_BANNER.SEARCH_IS_ON}</span>
  </div>
);

export default VisualSearchOnBanner;
